/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
// eslint-disable-next-line no-unused-vars
import React, { useState, useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Sidebar from "../../../components/AdminComponents/SideNav";
import {
  CaAdminMenu,
  SecondaryNavCaAdmin,
} from "../../../components/AdminComponents/MenuItems";
import SecondaryNav from "../../../components/AdminComponents/SecondaryNav";
import {
  EditOutlined,
  DeleteTwoTone,
  InfoCircleTwoTone,
  CheckCircleTwoTone,
  CheckOutlined,
  CloseOutlined,
} from "@ant-design/icons";
// eslint-disable-next-line no-unused-vars
import { Table, Button, Tag, Spin, Select, Popconfirm } from "antd";
import "../formStyles.css";
import moment from "moment";
import UsersTable from "../../../components/AdminComponents/UsersTable";
import { Form, Input, DatePicker, Modal } from "antd";
import Axios from "../../../api/Axios";
import dayjs from "dayjs";
import EditableImage from "../../../components/icons/EditIcon";
import EditSub from "../../../components/AdminComponents/Modals/EditSub";
import { message } from "antd";
import EditSubRow from "../../../components/AdminComponents/Modals/EditSubRow";
import CaSideNav from "../../../components/AdminComponents/CaSideNav";
import SecondaryNav2 from "../../../components/AdminComponents/SecondaryNav2";
import {
  capitalizeWords,
  ModuleColor,
} from "../../../components/icons/ApplicationColor";
import { GetFormattedDate } from "../../../components/utils/DateTimeUtils";

const { Option } = Select;
const { RangePicker } = DatePicker;

// import React, { useState } from "react";
// import { Table, Button } from "antd";

// eslint-disable-next-line no-unused-vars
const columns = [
  {
    title: "Products",
    dataIndex: "products",
    key: "products",
    width: 200,
    render: (tag) => {
      return (
        <Tag color="volcano">
          <span className="tag-container">{tag}</span>
        </Tag>
      );
    },
  },
  {
    title: "Billing",
    dataIndex: "billing",
    key: "billing",
  },
  {
    title: "Start Date",
    dataIndex: "startDate",
    key: "startDate",
  },
  {
    title: "End Date",
    dataIndex: "endDate",
    key: "endDate",
  },
  {
    title: "Actions",
    key: "actions",
    render: () => (
      <div>
        <EditOutlined
          style={{ cursor: "pointer", fontSize: "1.7rem" }}
          title="edit"
        />
        <DeleteTwoTone
          style={{
            cursor: "pointer",
            fontSize: "1.7rem",
            marginLeft: "0.9rem",
          }}
          title="delete"
          twoToneColor="#eb2f96"
        />
      </div>
    ),
  },
];
// function getDaySuffix(day) {
//   if (day >= 11 && day <= 13) {
//     return "th";
//   }
//   switch (day % 10) {
//     case 1:
//       return "st";
//     case 2:
//       return "nd";
//     case 3:
//       return "rd";
//     default:
//       return "th";
//   }
// }
const renderStatus = (text, record) => {
  if (record.status) {
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div
          style={{
            width: "1.8rem",
            height: "1.8rem",
            borderRadius: "50%",
            backgroundColor: "#52c41a",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CheckOutlined
            style={{ color: "#fff", fontSize: "1.2rem", fontWeight: "700" }}
          />
        </div>
      </div>
    );
  } else {
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div
          style={{
            width: "1.8rem",
            height: "1.8rem",
            borderRadius: "50%",
            backgroundColor: "#ff4d4f",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CloseOutlined
            style={{ color: "#fff", fontSize: "1rem", fontWeight: "600" }}
          />
        </div>
      </div>
    );
  }
  // else {
  //   return text;
  // }
};

// eslint-disable-next-line no-unused-vars
const data = [
  {
    key: "1",
    products: "Product A",
    billing: "$10/month",
    startDate: "2023-03-08",
    endDate: "2023-09-08",
  },
  {
    key: "2",
    products: "Product B",
    billing: "$15/month",
    startDate: "2023-04-08",
    endDate: "2023-10-08",
  },
];
const Subscription = () => {
  const { id } = useParams();
  const [messageApi, contextHolder] = message.useMessage();
  //console.log(id);
  const namingData = useSelector((state) => state.orgdeatil);
  //console.log(namingData);
  const [visible, setVisible] = useState(false);
  const [modalData, setModalData] = useState({});
  const handleRowClick = (record) => {
    //console.log(record);
    setModalData(record);
    setVisible(true);
  };

  const handleCancel = () => {
    setVisible(false);
  };
  const handleDelete = async (record) => {
    try {
      const res = await Axios.delete(`/orgsubscription/${record.id}/`, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      handleCancel();
      LoadApplications();
      CreateSuccessfull("deleted");
    } catch (err) {
      //console.log(err);
      CreateFailed("deleted");
    }
  };
  const columns2 = [
    {
      title: "MODULES",
      dataIndex: "application",
      key: "application",
      align: "center",
      render: (application) => {
        return (
          <Tag
            color={ModuleColor(application)}
            style={{
              minWidth: "15rem",
              textAlign: "center",
              maxWidth: "18rem",
              minHeight: "3rem",
            }}
          >
            <span
              className="tag-container"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                lineHeight: "3rem",
              }}
            >
              {application}
            </span>
          </Tag>
        );
      },
    },
    {
      title: "CONTRACT ID",
      dataIndex: "contract_id",
      key: "contract_id",
    },
    // {
    //   title: "ENROLLMENT TYPE",
    //   dataIndex: "enrollment_type",
    //   key: "enrollment_type",
    // },
    {
      title: "BILLING",
      dataIndex: "billing_cycle",
      key: "billing",
    },
    {
      title: "CATEGORY",
      dataIndex: "subscription_category",
      key: "subscription_category",
    },

    {
      title: "START DATE",
      dataIndex: "start_date",
      key: "start_date",
      editable: true,
      render: GetFormattedDate,
    },
    {
      title: "END DATE",
      dataIndex: "end_date",
      key: "end_date",
      editable: true,
      render: GetFormattedDate,
    },
    // {
    //   title: "PRODUCTS",
    //   dataIndex: "products",
    //   key: "products",
    //   render: (applications) => (
    //     <span>
    //       {applications.map((tag, index) => {
    //         let color;

    //         if (tag.name === "CO") {
    //           color = "orange";
    //         } else if (tag.name === "JDV2") {
    //           color = "blue";
    //         } else {
    //           color = "red";
    //         }
    //         return (
    //           <Tag
    //             color={color}
    //             key={index}
    //             title={tag.description}
    //             style={{ cursor: "pointer" }}
    //           >
    //             <span style={{ color: "black", fontWeight: "500" }}>
    //               {tag.name}
    //             </span>
    //           </Tag>
    //         );
    //       })}
    //     </span>
    //   ),
    // },
    // {
    //   title: "Active",
    //   dataIndex: "status",
    //   key: "status",
    //   render: renderStatus,
    // },
    // {
    //   title: "ACTIONS",
    //   key: "actions",
    //   render: (text, record) => {
    //     return (
    //       <div style={{ display: "flex", justifyContent: "center" }}>
    //         {/* <DeleteTwoTone onClick={handleClick(record)} /> */}
    //         <EditableImage handleRowClick={handleRowClick} recordId={record} />
    //         <Popconfirm
    //           title="Delete Subscription"
    //           description=" "
    //           onConfirm={() => handleDelete(record)}
    //           // onCancel={cancel}
    //           okText="Yes"
    //           cancelText="No"
    //         >
    //           <DeleteTwoTone
    //             style={{
    //               cursor: "pointer",
    //               fontSize: "1.8rem",
    //               marginLeft: "0.9rem",
    //             }}
    //             // onClick={() => {
    //             //   handleDelete(record);
    //             // }}
    //             title="delete"
    //             twoToneColor="#eb2f96"
    //           />
    //         </Popconfirm>
    //       </div>
    //     );
    //   },
    // },
  ];

  // eslint-disable-next-line no-unused-vars
  const [newProduct, setNewProduct] = useState(false);
  const [applications, setApplications] = useState([]);
  const [enrollments, SetEnrollments] = useState([]);
  const [category, setCategory] = useState([]);
  const [subscription, setSubscription] = useState([]);
  const [billings, setBillings] = useState([]);
  const [data2, setData2] = useState([]);
  const [loading, setLoading] = useState(true);
  const formRef = useRef();
  const userInfo = useSelector((state) => state.user);
  //console.log(userInfo);
  const handleReset = () => {
    formRef.current.resetFields();
  };
  const LoadUser2 = async () => {
    try {
      const res = await Axios.get(
        `/orgsubscriptionlist/${userInfo.data.organization.id}/`
      );
      //console.log(res.data);
      setData2(res.data);
      setLoading(false);
    } catch (err) {
      //console.log(err);
    }
  };
  const LoadOtherData = () => {
    LoadSubscriptions();
    LoadCategory();
    LoadBillings();
    LoadEnrollments();
    // LoadCategory();
    // LoadSubscriptions();
  };

  const LoadApplications = async () => {
    //console.log(id);
    try {
      const res = await Axios.get(`/nonorgproducts/${id}/`);
      //console.log(res.data);
      setApplications(res.data);
    } catch (err) {
      //console.log(err);
    }
  };
  const LoadEnrollments = async () => {
    try {
      const res = await Axios.get("/options/enrollment_type");
      //console.log(res.data);
      SetEnrollments(res.data);
    } catch (err) {
      //console.log(err);
    }
  };
  const LoadSubscriptions = async () => {
    try {
      const res = await Axios.get("/options/subscription_type/");
      //console.log(res.data);
      setSubscription(res.data);
    } catch (err) {
      //console.log(err);
    }
  };
  const LoadBillings = async () => {
    try {
      const res = await Axios.get("/options/billing_cycle");
      //console.log(res.data);
      setBillings(res.data);
    } catch (err) {
      //console.log(err);
    }
  };
  const LoadCategory = async () => {
    try {
      const res = await Axios.get("/options/subscription_category/");
      //console.log(res.data);
      setCategory(res.data);
    } catch (err) {
      //console.log(err);
    }
  };

  useEffect(() => {
    LoadUser2();
    // LoadApplications();
    // LoadSubscriptions();
    // LoadCategory();
    // LoadBillings();
    // LoadEnrollments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  //console.log(csrfToken);
  const onFinish = async (values, event) => {
    const { dateRange, ...otherValues } = values;

    const filteredValues = Object.fromEntries(
      Object.entries(otherValues).filter(([_, value]) => value !== undefined)
    );

    const startDate = dayjs(dateRange[0]);
    const endDate = dayjs(dateRange[1]);
    //console.log(dateRange[0]);

    const payload = {
      ...filteredValues,
      start_date: startDate.format("YYYY-MM-DD"),
      end_date: endDate.format("YYYY-MM-DD"),
      organization: parseInt(id, 10),
    };

    //console.log(payload);
    try {
      const res = await Axios.post("/orgsubscriptioncreate/", payload, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      CreateSuccessfull("created");
    } catch (err) {
      //console.log(err);
      CreateFailed("created");
    }
  };
  const CreateSuccessfull = (props) => {
    messageApi.open({
      type: "success",
      content: `Subscription has been ${props}.`,
      duration: 5,
    });
    setNewProduct(false);
    setLoading(true);
    LoadUser2();
    if (props === "created") {
      handleReset();
    } else {
      setExpandedRowKeys([]);
    }
  };

  const CreateFailed = (props) => {
    messageApi.open({
      type: "error",
      content: `Subscription has not been ${props}.`,
      duration: 5,
    });
  };
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const confirm = (e) => {
    //console.log(e);
    message.success("Click on Yes");
  };
  const cancel = (e) => {
    //console.log(e);
    message.error("Click on No");
  };
  return (
    <CaSideNav props={CaAdminMenu}>
      {contextHolder}

      <SecondaryNav2 id={parseInt(id)} menuItems={SecondaryNavCaAdmin} />
      <div className="form-container-2">
        {/* <div className="details-box">
          <InfoCircleTwoTone style={{ fontSize: "2rem" }} />
          <span className="details-text">
            <strong>Client ID</strong> : {namingData.id}&nbsp;&nbsp;{" "}
            <strong>Client Name</strong> : {namingData.name}
          </span>
        </div> */}
        <Spin spinning={loading}>
          <div className="sub-box-conatiner">
            <div className="subscription-box">
              <div className="sub-header">
                <h2 className="sub-text">
                  {capitalizeWords("Subscription Details")}
                </h2>
                {false && (
                  <>
                    {" "}
                    <Button
                      type="primary"
                      htmlType="button"
                      style={{
                        marginRight: "4rem",
                        marginTop: "2rem",
                      }}
                      className="small-add-btn"
                      onClick={() => {
                        setNewProduct((prev) => !prev);
                        setExpandedRowKeys([]);
                        // LoadOtherData();
                      }}
                    >
                      + Add
                    </Button>
                  </>
                )}
              </div>

              <Table
                dataSource={data2}
                columns={columns2}
                pagination={false}
                className="sub-table"
                rowKey="id"
                // size="small"
                style={{ margin: "2rem" }}
                // expandedRowKeys={expandedRowKeys}
                // expandIconColumnIndex={-1}
                // expandable={{
                //   expandedRowRender: (record) => (
                //     <EditSubRow
                //       record={record}
                //       setExpandedRowKeys={setExpandedRowKeys}
                //       CreateSuccessfull={CreateSuccessfull}
                //       CreateFailed={CreateFailed}
                //       subscription={subscription}
                //       category={category}
                //       enrollments={enrollments}
                //       billings={billings}
                //     />
                //   ),
                // }}
              />

              <EditSub
                record={modalData}
                visible={visible}
                onCancel={handleCancel}
                CreateSuccessfull={CreateSuccessfull}
                CreateFailed={CreateFailed}
                subscription={subscription}
                category={category}
                enrollments={enrollments}
                billings={billings}
              />
              {newProduct && (
                <div
                  style={{
                    marginLeft: "3rem",
                    marginBottom: "2rem",
                    width: "100%",
                  }}
                >
                  <Form layout="inline" onFinish={onFinish} ref={formRef}>
                    <Form.Item name="application" style={{ flex: 1.5 }}>
                      <Select
                        placeholder="Select application"
                        name="application"
                      >
                        {applications?.map((app) => (
                          <Option key={app.id} value={app.id}>
                            {app.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      name="contract_id"
                      style={{ flex: 1 }}
                      rules={[
                        {
                          pattern: /^[0-9]*$/,
                          message: "Please enter numbers only",
                        },
                      ]}
                    >
                      <Input placeholder="Contract_id" name="contractID" />
                    </Form.Item>
                    <Form.Item name="enrollment_type" style={{ flex: 1 }}>
                      <Select
                        placeholder="Enrollment Type"
                        name="enrollment_type"
                      >
                        {enrollments?.enrollment_type?.map((app) => (
                          <Option key={app} value={app}>
                            {app}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item name="billing_cycle" style={{ flex: 1 }}>
                      <Select placeholder="Billing" name="billing_cycle">
                        {billings?.billing_cycle?.map((app) => (
                          <Option key={app} value={app}>
                            {app}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item name="subscription_type" style={{ flex: 1 }}>
                      <Select
                        placeholder="Subscription Type"
                        name="subscription_type"
                      >
                        {subscription?.subscription_type?.map((app) => (
                          <Option key={app} value={app}>
                            {app}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item name="category" style={{ flex: 1 }}>
                      <Select placeholder="Category" name="category">
                        {category?.subscription_category?.map((app) => (
                          <Option key={app} value={app}>
                            {app}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item name="dateRange" style={{ flex: 2 }}>
                      <RangePicker
                        placeholder={["Start Date", "End Date"]}
                        name="dateRange"
                        format="MMM-DD-YYYY"
                      />
                    </Form.Item>
                    <Form.Item style={{ flex: 1 }}>
                      <div>
                        <Button
                          type="primary"
                          htmlType="submit"
                          style={{
                            background: "transparent",
                            border: "none",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <div
                              style={{
                                width: "1.8rem",
                                height: "1.8rem",
                                borderRadius: "50%",
                                backgroundColor: "#52c41a",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <CheckOutlined
                                title="submit"
                                style={{
                                  color: "#fff",
                                  fontSize: "1.2rem",
                                  fontWeight: "700",
                                }}
                              />
                            </div>
                          </div>
                        </Button>

                        <DeleteTwoTone
                          style={{
                            cursor: "pointer",
                            fontSize: "1.7rem",
                            marginLeft: "0.9rem",
                          }}
                          title="delete"
                          twoToneColor="#eb2f96"
                          onClick={() => {
                            setNewProduct(false);
                            handleReset();
                          }}
                        />
                      </div>
                    </Form.Item>
                  </Form>
                </div>
              )}
            </div>
          </div>
          {/* <UsersTable data={record} /> */}
        </Spin>
      </div>
    </CaSideNav>
  );
};

export default Subscription;
